/*
 * @Author: 小周
 * @Date: 2023-09-07 11:21:17
 * @LastEditTime: 2024-08-02 15:35:52
 * @LastEditors: MrZHLF
 * @Description:
 */
import { checkDevice } from './index'
/**
 *
 * @param {string} articleId 指定文章ID
 * @param {number} msgType 文章类型
 */
export function openApp(articleId, msgType) {
  var photoType = checkDevice()
  if ('IOS' == photoType) {
    // let params = encodeURIComponent(`id=${articleId}&msgType=${msgType}`)
    // location.href = `https://www.hndt.com/dowload/dxXw/index.html?${params}`
    location.href = `https://www.hndt.com/dowload/dxXw/index.html?id=${encodeURIComponent(
      articleId
    )}&msgType=${msgType}`
  } else if ('Android' == photoType) {
    let params = encodeURIComponent(`id=${articleId}&msgType=${msgType}`)
    window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.hnr.dxxw&android_schema=schemedxxw%3a%2f%2fhostdxxw%3a8080%2fpath?${params}`
  } else {
    window.location.href = 'https://static.hntv.tv/weiboshare/'
  }
}

/**
 *
 * @param {string} articleId 文章ID
 * @param {number} msgType  文章类型
 * @description 适用于传稿件文章ID 进行跳转
 */
export function openAppArticleId(articleId, msgType) {
  var photoType = checkDevice()
  if ('IOS' == photoType) {
    location.href = `https://www.hndt.com/dowload/dxXw/index.html?id=${encodeURIComponent(
      articleId
    )}&msgType=${msgType}`
  } else if ('Android' == photoType) {
    let str = encodeURIComponent(
      'id=' +
        encodeURIComponent(
          `hntvdxxw://Article/articleDetailViewController?articleId=${articleId}`
        ) +
        '&msgType=' +
        encodeURIComponent(msgType)
    )
    window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.hnr.dxxw&android_schema=schemedxxw%3a%2f%2fhostdxxw%3a8080%2fpath?${str}`
  } else {
    window.location.href = 'https://static.hntv.tv/weiboshare/'
  }
}

/**
 *
 * @param {string} msgType  文章类型
 * @param {number} redirectPath 底部导航
 * @descript 唤醒App并打开指定菜单栏
 */
export function openAppMenu(msgType = 30, redirectPath = 0) {
  var photoType = checkDevice()
  if ('IOS' == photoType) {
    let params = encodeURIComponent(
      `msgType=${msgType}&redirectPath=${redirectPath}&id=1111111111111111111`
    )
    window.location.href = `https://www.hndt.com/dowload/dxXw/index.html?${params}`
  } else if ('Android' == photoType) {
    let params = encodeURIComponent(
      `msgType=${msgType}&redirectPath=${redirectPath}&id=1111111111111111111`
    )
    window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.hnr.dxxw&android_schema=schemedxxw%3a%2f%2fhostdxxw%3a8080%2fpath?${params}`
  } else {
    window.location.href = 'https://static.hntv.tv/weiboshare/'
  }
}
